<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    :append-to-body="true"
    :custom-class="`equipment-container ${zsTjTheme}`"
    width="564px"
    @close="handleClose"
  >
    <template #title>
      <div class="modal-title">
        <div class="content">
          <div class="main-bg">
            <img v-if="current.part" :src="getImgUrl(current.part)" alt="" />
          </div>
          <div class="name">
            {{ current.part }}
          </div>
        </div>
      </div>
    </template>
    <ElScrollbar style="max-height: 60vh;" wrapStyle="overflow-x: hidden;">
      <div class="main-box">
        <div class="equipment-content">
          <div
            v-for="zb in list"
            :key="zb.content_id"
            :class="['card-item', { active: currentId === zb.content_id }]"
            @click="handleClickItem(zb)"
          >
            <div :class="['img-box']">
              <div class="img-wrap">
                <img :src="zb.icon" alt="" class="zb-icon" />
              </div>
              <div class="attr-box">
                <img class="jbnl1" :src="findAttrIcon(zb, 'jbnl1')" />
                <img v-if="zb.type !== '专用'" class="jbnl2" :src="findAttrIcon(zb, 'jbnl2')" />
              </div>
              <img src="@/assets/zs_imgs/zbtj/level-r-ur.png" alt="" class="ur-icon" />
              <img v-if="zb.type === '制作'" class="legend-icon" src="@/assets/zs_imgs/zbtj/zz-level-ur4.png" alt="" />
            </div>
            <span class="name" :title="zb.name">{{ zb.name }}</span>
          </div>
        </div>
      </div>
    </ElScrollbar>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import { attrIcon, splitStatString } from "@/views/wiki/zbtj/zs/abcs";

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    current: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(["zsTjTheme"])
  },
  watch: {
    visible(newVal) {
      if (newVal && this.current.content_id) {
        this.currentId = this.current.content_id;
      }
    }
  },
  data() {
    return {
      visible: false,
      currentId: undefined
    };
  },
  methods: {
    findAttrIcon(object, field) {
      const { jbnl1, jbnl2, type } = object.mainAttr;
      const name1 = jbnl1.label;
      let name2 = "";
      if (type !== "专用") {
        name2 = jbnl2.label;
      }
      let icon = "";
      switch (field) {
        case "jbnl1":
          icon = attrIcon[name1];
          break;
        case "jbnl2":
          icon = attrIcon[name2];
          break;
        default:
          break;
      }
      return icon;
    },
    handleClickItem(data) {
      this.currentId = data.content_id;
    },
    getImgUrl(name) {
      return require(`@/assets/zs_imgs/cultivation/equipment-icon-${name}.png`);
    },
    handleClose() {
      this.visible = false;
      if (!this.currentId) {
        this.$emit("close", undefined);
        return;
      }
      if (this.current.content_id === this.currentId) {
        this.currentId = undefined;
        return;
      }

      const findItem = this.list.find(item => item.content_id === this.currentId);
      this.$emit("close", findItem);
      this.currentId = undefined;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .equipment-container {
  padding: 0 12px 12px;
  background: linear-gradient(155deg, #262f3a 0%, #31415e 100%);
  .el-dialog__header {
    height: 54px;
    padding: 0;
    i {
      // color: #fff;
      transition: color 0.3s;
      // &:hover {
      //   color: #b6c6d9;
      // }
    }
    .modal-title {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .content {
        position: absolute;
        top: -19px;
        left: 50%;
        transform: translateX(-50%);
        .main-bg {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          width: 39px;
          height: 39px;
          margin-bottom: 7px;
          background: url("~@/assets/zs_imgs/cultivation/equipment-bg-icon.png") no-repeat;
          background-size: 100% 100%;
          img {
            width: 25px;
            height: 25px;
            object-fit: contain;
          }
        }
        .name {
          font-weight: 500;
          font-size: 12px;
          color: #cccccc;
          text-align: center;
        }
      }
    }
  }
  .el-dialog__body {
    padding: 0;
    .equipment-content {
      display: grid;
      grid-template-columns: repeat(5, 80px);
      row-gap: 16px;
      justify-content: space-between;
      padding: 16px;
      border-radius: 8px;
      background: rgba(0, 0, 0, 0.59);
      overflow: auto;
      .card-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 80px;
        cursor: pointer;
        transition: border-color 0.3s;
        &.active {
          .img-box {
            .img-wrap {
              border-color: #b6c6d9;
            }
          }
        }
        .img-box {
          position: relative;
          width: 80px;
          height: 80px;
          margin-bottom: 8px;
          border-radius: 4px;
          // border: 1px solid rgba(0, 0, 0, 0.59);
          background-image: url("~@/assets/zs_imgs/zbtj/list-item-bg.png");
          background-size: 100% 100%;
          // border: 1px solid transparent;
          .img-wrap {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            border: 2px solid transparent;
            .zb-icon {
              position: absolute;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .ur-icon {
            position: absolute;
            right: 2px;
            top: 0;
            width: 20px;
            height: 20px;
          }
          .legend-icon {
            position: absolute;
            left: 2px;
            top: 5px;
            width: 23px;
            height: 12px;
          }
          .attr-box {
            position: absolute;
            left: 4px;
            bottom: 4px;
            display: flex;
            column-gap: 2px;
            img {
              width: 16px;
              height: 16px;
              object-fit: contain;
            }
          }
        }
        .name {
          font-size: 13px;
          color: #cdcdcd;
        }
      }
    }
  }
}
/deep/ .equipment-container.light {
  background: linear-gradient(180deg, #effcff 0%, #ffffff 100%);
  border-radius: 8px;
  padding: 0;
  .el-dialog__header {
    .modal-title {
      .content {
        .name {
          font-size: 16px;
          color: #333;
        }
      }
    }
  }
  .el-dialog__body {
    padding: 12px 0;
    .equipment-content {
      background: rgba(163, 178, 189, 0.4);
      .card-item .name {
        color: #333;
      }
      .card-item {
        &.active {
          .img-box {
            .img-wrap {
              border-color: #ff6600;
            }
          }
        }
        .img-box {
          // border: 1px solid transparent;
          .img-wrap {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .main-box {
      padding: 12px;
    }
  }
}
</style>
